"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReservedTemplate = void 0;
const lit_html_1 = require("lit-html");
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const typedi_1 = require("typedi");
const control_1 = require("@common/form/control");
const domain_1 = require("@domain/services/domain");
const translation_1 = require("@translation/services/translation");
const country_1 = require("@common/services/country");
const user_1 = require("@auth/services/user");
const loader_1 = require("@common/loader/templates/loader");
/**
 * Всплывающее окно резервирования домена
 */
let ReservedPopup = class ReservedPopup extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Загрузка
         */
        this.loading = false;
        /**
         * Резервирование
         */
        this.reserving = false;
        /**
         * Параметры
         */
        this.params = {};
        /**
         * Успешная отправка
         */
        this.success = false;
        /**
         * Форма
         */
        this.form = new control_1.Form({
            name: new control_1.TextControl(''),
            email: new control_1.TextControl(''),
            phone: new control_1.TextControl(''),
            domain: new control_1.TextControl(''),
            country: new control_1.TextControl(''),
            message: new control_1.TextControl(''),
        });
        /**
         * Список стран
         */
        this.countries = {};
        this.domainService = typedi_1.Container.get(domain_1.DomainService);
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.countryService = typedi_1.Container.get(country_1.CountryService);
        this.userService = typedi_1.Container.get(user_1.UserService);
        this.init();
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        super.connectedCallback();
        const { name } = this.params;
        this.form.patchValue({
            domain: name,
        });
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Генерирует представление
     */
    render() {
        return (0, lit_html_1.html) `
            <div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-md modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-header pb-4">
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        
                        ${!this.success
            ? this.loading
                ? (0, lit_html_1.html) `
                            <div class="modal-body pt-0">
                                <div class="mb-5">
                                    ${(0, loader_1.getLoaderTemplate)(true, this.translationService)}       
                                </div>
                            </div>
                        ` : (0, lit_html_1.html) `
                                <div class="modal-body pt-0">
                                    <div class="mb-5">
                                        <h2 class="mb-5">${this.translationService.instant('av_request_reserve')}</h2>
                                        <p class="mb-5">${this.translationService.instant('av_request_reserve_description')}</p>
        
                                        <div class="row g-3 mb-5">
                                            <div class="col-6">
                                                <art-text-field class="d-block mb-3" name="name" placeholder="${this.translationService.instant('contactname')}" .required=${true} .control="${this.form.get('name')}" @enter="${this.reserve}"></art-text-field>
                                                <art-text-field class="d-block mb-3" name="email" placeholder="${this.translationService.instant('mail')}" .required=${true} .control="${this.form.get('email')}" @enter="${this.reserve}"></art-text-field>
                                                <art-text-field class="d-block mb-3" name="phone" placeholder="${this.translationService.instant('clientareaphonenumber')}" .control="${this.form.get('phone')}" @enter="${this.reserve}"></art-text-field>
                                                <art-text-field class="d-block mb-3" name="domain" placeholder="${this.translationService.instant('clientareahostingdomain')}" .control="${this.form.get('domain')}" .disabled="${true}"></art-text-field>
                                            </div>
                                            <div class="col-6 d-flex flex-column">
                                                <art-select-field class="d-block mb-3" name="country" placeholder="Select" .control="${this.form.get('country')}" .values="${this.countries}"></art-select-field>
                                                <art-text-field class="d-block mb-3" type="textarea" name="message" placeholder="${this.translationService.instant('av_purpose')}" .required=${true} .control="${this.form.get('message')}" style="flex: 1;" @enter="${this.reserve}"></art-text-field>
                                            </div>
                                        </div>
                                        
                                        <button class="btn btn-primary w-100" ?disabled="${this.reserving}" @click="${this.reserve}">${this.translationService.instant('supportticketsticketsubmit')}</button>
                                    </div>
                                </div>
                            ` : (0, lit_html_1.html) `
                                <div class="modal-body pt-0">
                                    <div class="mb-5">
                                        <h2 class="mb-5">${this.translationService.instant('av_request_reserve_success')}</h2>
                                        <p class="mb-5">${this.translationService.instant('please_wait_for_our_response')}</p>
                                    </div>
                                </div>
                            `}
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Инициализация состояния
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                const { data: userData } = yield this.userService.info();
                const { data: { items } } = yield this.countryService.getCountries();
                this.countries = items;
                this.form.patchValue({
                    country: userData.country || Object.keys(items)[0] || '',
                    email: userData.email || '',
                    name: userData.name || '',
                    phone: userData.phone || '',
                });
            }
            catch (err) {
                console.log(err);
            }
            finally {
                this.loading = false;
            }
        });
    }
    /**
     * Резервирует домен
     */
    reserve() {
        return __awaiter(this, void 0, void 0, function* () {
            this.reserving = true;
            try {
                const values = this.form.getValue();
                yield this.domainService.reserve(values);
                this.success = true;
            }
            catch (err) {
                if (err.errors) {
                    this.form.setErrors(err.errors);
                }
                this.reserving = false;
            }
        });
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ReservedPopup.prototype, "loading", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ReservedPopup.prototype, "reserving", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], ReservedPopup.prototype, "params", void 0);
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], ReservedPopup.prototype, "success", void 0);
ReservedPopup = __decorate([
    (0, decorators_js_1.customElement)('art-reserved-popup'),
    __metadata("design:paramtypes", [])
], ReservedPopup);
/**
 * Возвращает шаблон авторизации пользователя
 */
function getReservedTemplate(params) {
    return (0, lit_html_1.html) `<art-reserved-popup .params="${params}"></art-reserved-popup>`;
}
exports.getReservedTemplate = getReservedTemplate;
window.PopupController.registerTemplate('reserved', getReservedTemplate);
